import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';

type RowsDiscardConfirmationDialogProps = {
  onSubmit: () => void;
  onClose: () => void;
};

export const RowsDiscardConfirmationDialog = ({
  onClose,
  onSubmit,
}: RowsDiscardConfirmationDialogProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={handleOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="s">
          <DialogHeader>
            <DialogTitle>
              {t('Are you sure you want to discard rows?')}
            </DialogTitle>
          </DialogHeader>
          <DialogContent>
            <DialogDescription>
              {t(
                'Discarding these rows is irreversible. If you need to restore the data, you can return to the Data mapping step to reset all data to its original state.',
              )}
            </DialogDescription>
          </DialogContent>
          <DialogFooter>
            <Button size="large" variant="text" onClick={onClose}>
              {t('Cancel')}
            </Button>
            <Button size="large" color="error" onClick={onSubmit}>
              {t('Yes, discard rows')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};
